// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const PrivacyPolicySignStatusDto = {
    NotRequired: 'NOT_REQUIRED',
    NotSigned: 'NOT_SIGNED',
    SignedMostRecent: 'SIGNED_MOST_RECENT',
    SignedOutdated: 'SIGNED_OUTDATED',
} as const;

export type PrivacyPolicySignStatusDto = typeof PrivacyPolicySignStatusDto[keyof typeof PrivacyPolicySignStatusDto];



